module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "visible",
    class: _vm.microNoteIsCompleted && _vm.showButtons ? 'score-container' : 'wordbank-container',
    attrs: {
      "id": "bottomShelf"
    }
  }, [_vm._c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.microNoteIsCompleted) ? _vm._c('div', [(_vm.showButtons) ? _vm._c('div', [_vm._c('MicroNoteScore'), _vm._v(" "), _vm._c('StudyIntervalButtons', {
    attrs: {
      "microNote": _vm.microNote
    }
  })], 1) : _vm._c('div', {
    staticClass: "continue"
  }, [_vm._c('h3', [_vm._v("Ready to continue?")]), _vm._v(" "), _vm._c('div', {
    staticClass: "btn-group"
  }, [_vm._c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.previousMicroNote($event)
      }
    }
  }, [_vm._c('i', {
    staticClass: "mdi mdi-chevron-left"
  }), _vm._v("   Previous")]), _vm._v(" "), _vm._c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.nextMicroNote($event)
      }
    }
  }, [_vm._v("Next   "), _vm._c('i', {
    staticClass: "mdi mdi-chevron-right"
  })])])])]) : _vm._e()]), _vm._v(" "), (!_vm.microNoteIsCompleted) ? _vm._c('div', {
    staticClass: "wordbank-wrapper"
  }, [_vm._c('div', {
    staticClass: "wordbank-toggle"
  }, [_vm._c('span', {
    staticClass: "lbl"
  }, [_vm._v("Word bank")]), _vm._v(" "), _vm._c('BoolSwitch', {
    attrs: {
      "toggle-bool": _vm.wordbankVisible,
      "toggle-function": _vm.toggleWordbank,
      "on-text": "On",
      "off-text": "Off"
    }
  })], 1), _vm._v(" "), (_vm.wordbankVisible) ? _vm._c('Wordbank', {
    attrs: {
      "words": _vm.wordbankWords
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c1a13126!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-studier/BottomShelf.vue
// module id = 711
// module chunks = 1